import { LAB_SAMPLE_STATUSES } from '@/config/constants';

const receivedSamplesColumns = {
  orderId: {
    key: 'orderId',
    label: 'orderId',
    type: 'function',
    sortable: false,
    minWidth: 100,
    get: (value, row) => (row.children ? value : ''),
  },
  groupingId: {
    key: 'groupingId',
    label: 'groupCode',
    type: 'function',
    sortable: false,
    minWidth: 120,
    get: (value, row) => (row.children ? value : ''),
  },
  groupingUpdatedAt: {
    key: 'groupingUpdatedAt',
    label: 'updatedAt',
    type: 'datetime',
    sortable: false,
    minWidth: 120,
  },
  updatedAt: {
    key: 'updatedAt',
    label: 'sampleTimestampChange',
    type: 'datetime',
    sortable: false,
    minWidth: 120,
  },
  lastModifiedAt: {
    key: 'lastModifiedAt',
    label: 'timestampChange',
    type: 'datetime',
    sortable: false,
    minWidth: 120,
  },
  latestPrint: {
    key: 'latestPrint',
    label: 'latestPrint',
    type: 'datetime',
    sortable: false,
    minWidth: 120,
  },
  id: {
    key: 'labSampleCode',
    label: 'sampleId',
    type: 'function',
    sortable: false,
    minWidth: 150,
    get: (value, row) => (row.children ? '' : value),
  },
  locationName: {
    key: 'locationName',
    label: 'location',
    type: 'text',
    sortable: 'custom',
    minWidth: 200,
  },
  productCode: {
    key: 'productCode',
    label: 'productCode',
    type: 'text',
    sortable: false,
    minWidth: 130,
  },
  productName: {
    key: 'productName',
    label: 'productName',
    type: 'text',
    sortable: false,
    minWidth: 130,
  },
  customerProductName: {
    key: 'customerProductName',
    label: 'customerSampleCode',
    type: 'text',
    sortable: false,
    minWidth: 200,
  },
  orderName: {
    key: 'orderName',
    label: 'orderName',
    type: 'text',
    sortable: false,
    minWidth: 130,
  },
  lot: {
    key: 'lot',
    label: 'lot',
    type: 'text',
    sortable: false,
    minWidth: 130,
  },
  lotDate: {
    key: 'date',
    label: 'lotDate',
    type: 'date',
    sortable: false,
    minWidth: 130,
  },
  orderSentAt: {
    key: 'orderSentAt',
    label: 'orderDate',
    type: 'date',
    sortable: false,
    minWidth: 130,
  },
  sector: {
    key: 'sector',
    label: 'sector',
    type: 'enum',
    enum: 'sectors',
    sortable: false,
    minWidth: 130,
  },
  packagesNumber: {
    key: 'packagesNumber',
    label: 'packagesNumber',
    type: 'text',
    sortable: false,
    minWidth: 130,
  },
  notes: {
    key: 'notes',
    label: 'customerNotes',
    type: 'text',
    sortable: false,
    minWidth: 130,
  },
  finalCustomer: {
    key: 'finalCustomer',
    label: 'finalCustomer',
    type: 'text',
    sortable: false,
    minWidth: 130,
  },
  finalCustomerRef: {
    key: 'finalCustomerRef',
    label: 'finalCustomerRef',
    type: 'text',
    sortable: false,
    minWidth: 130,
  },
  sampleDescription: {
    key: 'sampleDescription',
    label: 'sampleDescription',
    type: 'enum',
    enum: 'sampleDescriptions',
    sortable: false,
    minWidth: 200,
  },
  comments: {
    key: 'comments',
    label: 'sampleInstructions',
    type: 'text',
    sortable: false,
    minWidth: 200,
  },
  costCenter: {
    key: 'costCenter',
    label: 'costCenter',
    type: 'text',
    sortable: false,
    minWidth: 200,
  },
  rejectReason: {
    key: 'rejectReason',
    label: 'rejectReason',
    type: 'text',
    sortable: false,
    minWidth: 200,
  },
  stabilityToken: {
    key: 'stabilityTimepointToken',
    label: 'stabilityToken',
    type: 'function',
    sortable: false,
    minWidth: 100,
    get: (value, row) => (row.children ? '' : value || ''),
  },
  actions: {
    key: 'actions',
    label: 'actions',
    type: 'actions',
    sortable: false,
    fixed: true,
    minWidth: 200,
    buttons: [
      {
        name: 'accept',
        icon: 'fas fa-check-square',
        showCondition: (row) =>
          (!row.children && row.status === LAB_SAMPLE_STATUSES.PENDING) ||
          (row.children &&
            row.children.every(
              (child) =>
                child.status === LAB_SAMPLE_STATUSES.PENDING ||
                child.status === LAB_SAMPLE_STATUSES.ACCEPTED
            )),
        permissions: ['receivedSamplesManage'],
      },
      {
        name: 'refuse',
        icon: 'fas fa-do-not-enter',
        /*
         * In the single line show button only if the status is pending.
         * In the group line show button if at least one is pending and
         * the others are pending or rejected
         */
        showCondition: (row) =>
          (!row.children && row.status === LAB_SAMPLE_STATUSES.PENDING) ||
          (row.children &&
            // row.children.some(
            //   (child) => child.status === LAB_SAMPLE_STATUSES.PENDING
            // ) &&
            row.children.every(
              (child) =>
                child.status === LAB_SAMPLE_STATUSES.PENDING ||
                child.status === LAB_SAMPLE_STATUSES.REJECTED
            )),
        permissions: ['receivedSamplesManage'],
      },
      {
        name: 'groupingInfo',
        icon: 'fas el-icon-question',
        permissions: ['receivedSamplesManage'],
      },
      // {
      //   name: 'downloadDetails',
      //   icon: 'fas fa-file-pdf',
      //   showCondition: (row) => !row.children,
      //   permissions: ['receivedSamplesDownload'],
      // },
      {
        name: 'downloadAttachment',
        icon: 'fas fa-paperclip',
        showCondition: (row) => row.hasAttachments || row.groupHasAttachments,
        permissions: ['receivedSamplesDownload'],
      },
      {
        name: 'quarantine',
        icon: 'fas fa-vials',
        showCondition: (row) =>
          (!row.children && row.status === LAB_SAMPLE_STATUSES.PENDING) ||
          (row.children &&
            row.children.every(
              (child) => child.status === LAB_SAMPLE_STATUSES.PENDING
            )),
        permissions: ['receivedSamplesManage'],
      },
    ],
  },
};

export default receivedSamplesColumns;
